<template>
  <el-pagination
    @current-change="changePage"
    layout="prev,pager,next"
    :small="small"
    :background="background"
    :current-page="page"
    :page-size="pageSize"
    :style="defaultStyle"
    :total="total"
    :hide-on-single-page="true"
  ></el-pagination>
</template>

<script>
  export default {
    name: "pager",
    props: {
      page: {
        type: Number,
        default: 1
      },
      total: {
        type: Number,
        default: 0
      },
      pageSize: {
        type: Number,
        default: 30
      },
      defaultStyle: {
        type: String,
        default: "text-align: center;margin:auto"
      },
      small: {
        type: Boolean,
        default: false
      },
      background: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      changePage(curPage) {
        this.$emit("pagecallback", { page: curPage });
      }
    }
  };
</script>

<style scoped>
  .el-pagination {
    padding: 6px 4px;
    justify-content: center;
  }
</style>
